const DEMO_SESSION_KEY = "clearhealth_demo_session";
const DEMO_RECORDS_KEY = "clearhealth_demo_records";

const nowIso = () => new Date().toISOString();

const readJson = (key, fallback) => {
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || "null");
    return parsed ?? fallback;
  } catch {
    return fallback;
  }
};

const writeJson = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Demo mode must not break live app usage when storage is unavailable.
  }
};

const notify = () => {
  try {
    window.dispatchEvent(new CustomEvent("clearhealth-demo-session-change"));
  } catch {
    // Ignore non-browser contexts.
  }
};

export const getDemoSession = () =>
  readJson(DEMO_SESSION_KEY, { active: false, workflow: null, startedAt: null });

export const isDemoModeActive = () => getDemoSession()?.active === true;

export const startDemoSession = ({ workflow = "general", route = "" } = {}) => {
  const session = {
    active: true,
    workflow,
    route,
    startedAt: nowIso(),
    updatedAt: nowIso(),
  };
  writeJson(DEMO_SESSION_KEY, session);
  notify();
  return session;
};

export const endDemoSession = () => {
  localStorage.removeItem(DEMO_SESSION_KEY);
  localStorage.removeItem(DEMO_RECORDS_KEY);
  notify();
};

export const makeDemoId = (prefix = "demo") =>
  `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const getDemoRecords = () => readJson(DEMO_RECORDS_KEY, {});

export const saveDemoRecord = (collectionName, payload = {}, id = null) => {
  const records = getDemoRecords();
  const recordId = id || makeDemoId(collectionName || "record");
  const collection = records[collectionName] || {};
  collection[recordId] = {
    ...(collection[recordId] || {}),
    ...payload,
    id: recordId,
    demo: true,
    updatedAt: nowIso(),
    ...(!collection[recordId] ? { createdAt: nowIso() } : {}),
  };
  records[collectionName] = collection;
  writeJson(DEMO_RECORDS_KEY, records);
  notify();
  return { id: recordId, data: collection[recordId] };
};

export const getDemoCollection = (collectionName) => {
  const records = getDemoRecords();
  return Object.values(records[collectionName] || {});
};

export const demoWriteResult = (collectionName, payload = {}, id = null, message = "Demo saved locally.") => {
  const saved = saveDemoRecord(collectionName, payload, id);
  return {
    success: true,
    id: saved.id,
    demo: true,
    message,
    data: saved.data,
  };
};

